module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;   var u = require('util/Util.js').default;
    var dateUtil = require('shared/DateUtil.js').default;

    ; __append("\r\n\r\n    <div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\" style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n             width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) + 6 ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append("; \">\r\n\r\n        <div class=\"size-handle-top\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n        <div class=\"size-handle-left\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n        <div class=\"pf-control-core pf-selectable\" style=\"display:inline-flex; line-height: 100%\">\r\n            <div style=\"margin-right: 3px;\r\n                align-items : center;\r\n                height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n                width: ")
    ; __append(escapeFn( u.extractNum(width)-30 ))
    ; __append("px;\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n                border: ")
    ; __append(escapeFn(borderSize))
    ; __append("px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\r\n                font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append(";\r\n                font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n                font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append(";\r\n                font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n                color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(";\r\n                line-height: ")
    ; __append(escapeFn( u.extractNum(height) - 1 ))
    ; __append("px;\r\n                padding: 0 1px 4px;\r\n                background-color: ")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\">\r\n                <div style=\"margin-left: 2px; overflow: hidden;\">")
    ; __append(escapeFn(dateUtil.getFormattedDate(specificDisplay, format)))
    ; __append("</div>\r\n            </div>\r\n           \r\n            <img draggable=\"false\" src=\"")
    ; __append( require('common/icons/calendar.gif') )
    ; __append("\" width=\"16px\" height=\"16px;\"\r\n                style=\"margin-top: 0px; vertical-align: middle;\" />\r\n\r\n        </div>\r\n        <div class=\"size-handle-right\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n        <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    </div>")
  }
  return __output;

}